import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=b2b04a18&"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports